import styled from 'styled-components';
import type { MoreGroup } from '@/core/models/more';
import { MoreRow } from './MoreRow';

const Card = styled.section`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px;
`;
const Title = styled.h2`
  margin: 0 0 8px;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.color.textPrimary};
`;

export function MoreCard({ group }: { group: MoreGroup }) {
  return (
    <Card>
      <Title>{group.title}</Title>
      <div>{group.rows.map((r) => <MoreRow key={r.label} row={r} />)}</div>
    </Card>
  );
}
